import CustomerService from "@/services/CustomerService.js";
import { ls } from "@/utilities";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    cities: null,
    provinces: null,
    customer_uuid: null,
    customer_token: ls.get('customer_token'),
    customer_info: ls.get('customer_info'),
    customer_address: ls.get('customer_address')
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_CITIES(state, cities) {
      state.cities = cities;
    },
    SET_PROVINCES(state, provinces) {
      state.provinces = provinces;
    },
    SET_CUSTOMER_UUID(state, uuid) {
      state.customer_uuid = uuid;
    },
    SET_CUSTOMER_TOKEN(state, token) {
      ls.set('customer_token', token);
    },
    SET_INFO(state, customer_info) {
      ls.set('customer_info', customer_info);
    },
    SET_ADDRESS(state, address) {
      ls.set('customer_address', address);
    },
    SET_CUSTOMER_CONTACT(state, contact_info) {
      ls.set('customer_contact', contact_info);
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async getCities({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_CITIES", []); // clear init
      try {
        let response = await CustomerService.getCities(request);
        commit("SET_CITIES", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getProvinces({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await CustomerService.getProvinces(request);
        commit("SET_PROVINCES", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async saveBillingInfo({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);

      try {
        await CustomerService.saveBillingInfo(request);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getCustomerToken({ state, commit }, request) {
      commit("SET_LOADING", true);
      const payload = {
        param: {
          customer_uuid: state.customer_uuid,
        },
        header: request.header
      };
      try {
        const { token } = await CustomerService.getCustomerToken(payload);
        commit("SET_CUSTOMER_TOKEN", token);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    }
  },
  getters: {
    provinces: state => {
      return state.provinces;
    },
    cities: state => {
      return state.cities;
    },
    loading: state => state.loading,
    customerToken: state => state.customer_token,
    errors: state => state.errors,
    customerInfo: state => state.customer_info,
    customerAddress: state => state.customer_address
  }
};
